module.exports = __webpack_public_path__ + "static/media/222-Sturz-Ansprechen-Teil2-Milo_ID_19.1d39052c.mp3";